import PropTypes from "prop-types";
import IconBase from "./IconBase";

// Rows of cards, so it reads as the counterpart to GridIcon rather than as a
// bulleted list (which is the array field type).
const ListIcon = ({ toggleColor, ...props }) => (
    <IconBase style={toggleColor ? { color: toggleColor } : undefined} {...props}>
        <rect x="3" y="4" width="18" height="4.25" rx="1.5" />
        <rect x="3" y="9.875" width="18" height="4.25" rx="1.5" />
        <rect x="3" y="15.75" width="18" height="4.25" rx="1.5" />
    </IconBase>
);

ListIcon.propTypes = {
    toggleColor: PropTypes.string,
};

export default ListIcon;
